// extracted by mini-css-extract-plugin
export default {"card-categoria":"CardsCategorias_card-categoria__jVzE8","icone":"CardsCategorias_icone__NsF4u"};